





















import { Component, Mixins, } from "vue-property-decorator";
import { DepartmentGroup } from "../../../domain/department";
import SelectorDialogMixin from "../../system/dialogs/mixins/SelectorDialogMixin.vue";
import { ISingleSelectableAsynchronously } from "../../system/selectors";
import DepartmentGroupFinder from "../selectors/DepartmentGroupFinder.vue";

@Component({
  components: {
    selector: DepartmentGroupFinder,
  },
})
export default class DepartmentGroupButtonSelectorDialog extends Mixins(SelectorDialogMixin) implements ISingleSelectableAsynchronously<DepartmentGroup> {
  get title(): string {
    return this.$wording.common.departmentGroup + "選択";
  }

  get isCancelable(): boolean {
    return true;
  }

  async selectOption(defaultOption?: DepartmentGroup): Promise<DepartmentGroup> {
    return this.show<DepartmentGroup>(defaultOption);
  }

  onClicked() {
    this.select();
  }
}
